export function generateClasses(classes) {
    return Object.keys(classes)
        .map(function (className) { return (classes[className] ? className : null); })
        .filter(function (cls) { return !!cls; })
        .join(' ');
}
